document.addEventListener('DOMContentLoaded', function() {
  const academySlider = document.querySelector('.academy-slider');
  
  if (academySlider) {
    const swiper = new Swiper('.academy-slider', {
      slidesPerView: 3.5,
      spaceBetween: 14,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.academy-slider-nav-btn-next-mob',
        prevEl: '.academy-slider-nav-btn-prev-mob',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        520: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        960: {
          slidesPerView: 2.5,
          spaceBetween: 12,
          navigation: {
            nextEl: '.academy-slider-nav-btn-next',
            prevEl: '.academy-slider-nav-btn-prev',
          }
        },
        1070: {
          slidesPerView: 3,
          spaceBetween: 14,
          navigation: {
            nextEl: '.academy-slider-nav-btn-next',
            prevEl: '.academy-slider-nav-btn-prev',
          }
        },
        1280: {
          slidesPerView: 4.1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.academy-slider-nav-btn-next',
            prevEl: '.academy-slider-nav-btn-prev',
          }
        },
      },
    });
  }
});